import type {User} from "../interfaces/User";

export const isClient = (user: User): boolean => {
  if (user?.roleId === 1) return true;
  return false;
};
